import { Box, Button, Popper } from "@material-ui/core";
import ChatIcon from "@material-ui/icons/Chat";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";

import Chatbot from "react-chatbot-kit";
import "react-chatbot-kit/build/main.css";
import config from "./config.js";
import MessageParser from "./MessageParser";
import ActionProvider from "./ActionProvider";
import { useChatbotStore } from "../../../../store/chatbot.jsx";
import { useTranslation } from 'react-i18next';

export function AtChatbot() {
    const { t } = useTranslation();
    const session_id = sessionStorage.getItem("session_id");
    const setAnchorEl = useChatbotStore((state) => state.setAnchorEl);
    const anchorEl = useChatbotStore((state) => {
        return document.getElementById(state.anchorEl);
    });

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget.id);
        const btn = document.getElementsByClassName(
            "react-chatbot-kit-chat-btn-send"
        );
        if (btn.length) {
            btn[0].disabled = false;
        }
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    const loadMessages = () => {
        const messages = JSON.parse(localStorage.getItem("chat_messages"));
        return messages;
    };

    return (
        <>
            <Box
                style={{
                    padding: 30,
                    paddingTop: 10,
                    paddingBottom: 10,
                    display: "flex",
                    placeContent: "end",
                    position: "fixed",
                    zIndex: 1100,
                    bottom: "25px",
                    right: 0,
                }}
            >
                <Button
                    id="btn-chatbot"
                    aria-describedby={id}
                    aria-label="show chatbot"
                    onClick={handleClick}
                    startIcon={
                        open ? (
                            <CloseIcon fontSize="large" />
                        ) : (
                            <ChatIcon fontSize="large" />
                        )
                    }
                    variant="contained"
                    style={{ backgroundColor: "#FE7100", color: "white" }}
                >
                    {open ? t('popover.atis.close') : t('popover.atis.open')}
                </Button>
                <Popper
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    placement="top-end"
                    transition
                    style={{
                        zIndex: 5000,
                        marginBottom: 10,
                    }}
                >
                    <Box>
                        <Chatbot
                            key={session_id}
                            config={config}
                            messageParser={MessageParser}
                            actionProvider={ActionProvider}
                            headerText={t('popover.atis.title')}
                            placeholderText={t('popover.atis.placeholder')}
                            messageHistory={loadMessages()}
                            runInitialMessagesWithHistory={false}
                        />
                    </Box>
                </Popper>
            </Box>
        </>
    );
}